import { Icon } from "materia"
import { modifiers } from "ui-tools"
import s from "./Likes.module.scss"

type LikesProps = { count: number | undefined }
export const Likes = ({ count }: LikesProps) => {
  const isDisabled = count === undefined

  return (
    <div className={modifiers(s, "likes", { isDisabled })}>
      <Icon icon="Like" size="small" title="Likes" />
      <span>{isDisabled ? "—" : count}</span>
    </div>
  )
}
